
import { Routes } from '@angular/router';
import { AdminPage } from './bi/admin/controller/adminPage.component';
// BI-ADMIN
import { CubeComponent } from './bi/admin/controller/cube.component';
import { DataEngine } from './bi/admin/controller/dataEngine.component';
import { DataSourceComponent } from './bi/admin/controller/dataSource.component';
import { DimensionComponent } from './bi/admin/controller/dimension.component';
import { dimLvlPermComponent } from './bi/admin/controller/dimLvlPermissions.component';
import { MeasureComponent } from './bi/admin/controller/measure.component';
import { pageAuthorizationComponent } from './bi/admin/controller/pageAuthorization.component';
import { roleAuthorizationComponent } from './bi/admin/controller/roleAuthorization.component';
import { editRoleAuthorizationComponent } from './bi/admin/controller/editRoleAuthorization.component';
import { RecordFormatComponent } from './bi/admin/controller/recordFormat.component';
import { ScopeComponent } from './bi/admin/controller/scope.component';
import { targetComponent } from './bi/admin/controller/target.component';
import { tenantConfigComponent } from './bi/admin/controller/tenantConfiguration.component';
import { UomComponent } from './bi/admin/controller/uom.component';
import { ValueStreamComponent } from './bi/admin/controller/valueStream.component';
import { POCWizard } from './bi/admin/pocdesigner/pocWizard.component';
import { BulkUploadComponent } from './bulkUpload/bulkUpload';
import { CobComponent } from './cob/cob.component';
// employee
import { AddEmployeesComponent } from './employee/addEmployees';
import { EmployeesListingPage } from './employee/employeeList';
import { EmployeeSearch } from './employee/employeeSearch';
import { MenuComponent } from './menu/menu';
import { NoContentComponent } from './no-content';
//  Announcements
import { Announcements } from './programManagement/announcements/announcements';

import { CreateTenantComponent } from './superAdmin/createTenant';
import { TenantManagementComponent } from './superAdmin/tenantManagement';
import { UpdateTenantComponent } from './superAdmin/updateTenant';
import { SwitchUserComponent } from './switchUser/switchUser';
import { AddDesignationComponent } from './tools/addDesignation';
import { AddOrgUnitTypeComponent } from './tools/organizationUnit/organizationUnit';
import { OrgUnitTypePageComponent } from './tools/organizationUnit/organizationUnitList';
import { AddEmployementTypeComponent } from './tools/addEmpType';
import { AddGradeComponent } from './tools/addGrade';
import { AddManagerLevelComponent } from './tools/addMgrLevel';
import { DesignationPageComponent } from './tools/designationList';

import { EmployementTypePageComponent } from './tools/empTypeList';
import { GradePageComponent } from './tools/gradeList';
import { ManagerLevelComponent } from './tools/mgrLevelList';
import { AddParentOrganizationComponent } from './tools/org/addParentOrganization';
import { OrganizationPage } from './tools/org/organizationList';
import { AddUsersToRolesComponent } from './tools/rolesAndPermission/addUsersToRole';
import { CreateRolesAndPermissionComponent } from './tools/rolesAndPermission/createRolesAndPermission';
import { EmployeeInRoleComponent } from './tools/rolesAndPermission/employeesInRole';
import { RolesAndPermissionComponent } from './tools/rolesAndPermission/rolesAndPermission';
import { TenantPreferenceComponent } from './tools/tenantPreference';
import { AddUserGroupComponent } from './tools/userGroup/addUserGroup';
import { AddUsersToGroupComponent } from './tools/userGroup/addUsersToGroup';
import { EmployeeInGroupComponent } from './tools/userGroup/employeesInGroup';
import { UserGroupPage } from './tools/userGroup/userGroup';

import { NotificationGridComponent } from './tools/notificationEditor/notificationGridComponent';
import { EditNotificationComponent } from './tools/notificationEditor/editNotificationComponent';
import { BuildDetailsComponent } from './superAdmin/buildDetailsComponent';
import { ClearCacheComponent } from './tools/clearComponent/clearComponent';
import { EmailNotification } from './programManagement/emailNotification/emailNotification'
import { MobileAppManagementComponent } from './superAdmin/mobileAppManagement';
import { PasswordPolicyComponent } from './tools/passwordPolicy/passwordPolicy';
import { BulkResignComponent } from './bulkResign/bulkResign.component';
import { ManageOperationComponent } from './tools/operations/manageOperation.component';


export const ROUTES: Routes = [
  { path: '', redirectTo: '/menu', pathMatch: 'full' },
  {
    path: 'biAdmin', component: AdminPage,
    children: [
      // BI-MDM
      { path: 'pageAuthorization', component: pageAuthorizationComponent },
      {
        path: 'roleAuthorization', component: roleAuthorizationComponent,
        children: []
      },
      { path: 'editRoleAuth', component: editRoleAuthorizationComponent },
      { path: 'dimLvlPermissions', component: dimLvlPermComponent },
      { path: 'tenantConfiguration', component: tenantConfigComponent },
      { path: 'target', component: targetComponent },
      { path: 'cube', component: CubeComponent },
      { path: 'measure', component: MeasureComponent },
      { path: 'uom', component: UomComponent },
      { path: 'scope', component: ScopeComponent },
      { path: 'dimension', component: DimensionComponent },
      { path: 'valueStream', component: ValueStreamComponent },
      { path: 'dataSource', component: DataSourceComponent },
      { path: 'recordFormat', component: RecordFormatComponent },
      { path: 'dataEngine', component: DataEngine },
      { path: 'wizard', component: POCWizard }

    ]
  },
  {
    path: 'menu', component: MenuComponent,
    children: [
      { path: 'employeesList', component: EmployeesListingPage },
      { path: 'employeeSearch', component: EmployeeSearch },
      { path: 'addEmployee', component: AddEmployeesComponent },
      { path: 'switch', component: SwitchUserComponent },
      { path: 'designationList', component: DesignationPageComponent },
      { path: 'organizationUnitType', component: OrgUnitTypePageComponent },
      { path: 'userGroup', component: UserGroupPage },
      { path: 'addDesignation', component: AddDesignationComponent },
      { path: 'addOrgUnitType', component: AddOrgUnitTypeComponent },
      { path: 'addUserGroup', component: AddUserGroupComponent },
      { path: 'addUsersToGroup', component: AddUsersToGroupComponent },
      { path: 'empTypeList', component: EmployementTypePageComponent },
      { path: 'addEmpType', component: AddEmployementTypeComponent },
      { path: 'gradeList', component: GradePageComponent },
      { path: 'addGrade', component: AddGradeComponent },
      { path: 'mgrLevelList', component: ManagerLevelComponent },
      { path: 'addMgrLevel', component: AddManagerLevelComponent },
      { path: 'addParentOrganization', component: AddParentOrganizationComponent },
      { path: 'rolesAndPermission', component: RolesAndPermissionComponent },
      { path: 'manageOperations', component: ManageOperationComponent },
      { path: 'cob', component: CobComponent },
      { path: 'bulkResignUpload', component: BulkResignComponent },
      { path: 'createRoles', component: CreateRolesAndPermissionComponent },
      { path: 'addUsers', component: AddUsersToRolesComponent },
      { path: 'organizationList', component: OrganizationPage },
      { path: 'EmployeeInRole', component: EmployeeInRoleComponent },
      { path: 'EmployeeInGroup', component: EmployeeInGroupComponent },
      { path: 'announcementProgram', component: Announcements },
      { path: 'bulkupload', component: BulkUploadComponent },
      { path: 'tenantPreference', component: TenantPreferenceComponent },
      { path: 'buildDetails', component: BuildDetailsComponent },
      { path: 'tenantManagement', component: TenantManagementComponent },
      { path: 'createTenant', component: CreateTenantComponent },
      { path: 'updateTenant', component: UpdateTenantComponent },
      { path: 'notifications', component: NotificationGridComponent },
      { path: 'editNotifications', component: EditNotificationComponent },
      { path: 'cache', component: ClearCacheComponent },
      { path: 'emailNotification', component: EmailNotification },
      { path: 'mobileAppManagement', component: MobileAppManagementComponent },
      { path: 'passwordPolicy', component: PasswordPolicyComponent }
    ]
  },
  { path: '**', component: NoContentComponent },
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts